import React from 'react';
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Divider,
} from '@material-ui/core';

const Dialog = (props) => {
  const { open, onClose, title, children, leftAction, action, ...rest } = props;

  return (
    <MuiDialog
      onClose={onClose}
      open={open}
      keepMounted={false}
      {...rest}
      PaperProps={{ style: { borderRadius: 20 } }}
    >
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button autoFocus onClick={onClose}>
          Tutup
        </Button>
        <div style={{ display: 'flex' }}>
          <Divider />
          {leftAction && (
            <Button autoFocus color="primary" onClick={leftAction.onClick} {...action.props}>
              {leftAction.label}
            </Button>
          )}
          {action && (
            <Button
              autoFocus
              onClick={action.onClick}
              color="primary"
              disabled={action.disabled}
              style={{
                cursor: action.disabled ? 'not-allowed' : 'pointer',
                pointerEvents: 'auto',
              }}
              {...action.props}
            >
              {action.label}
            </Button>
          )}
        </div>
      </DialogActions>
    </MuiDialog>
  );
};

export default Dialog;
